import React, { useContext } from "react";
import "./style.scss";
import { StoreContext } from "../../store/store";

const FollowButton = ({ user, show = true }) => {
  const { state, actions } = useContext(StoreContext);
  const { account, session } = state;

  const followUser = (id) => {
    if (!session || !account) {
      actions.alert("Please Sign In");
      return;
    }
    actions.followUser({ id, userId: account._id });
  };
  const followed = !!user && (account.following ?? []).includes(user._id);
  if (!show) {
    return null;
  }
  if (user && account._id === user._id) {
    return null;
  }
  if (followed) {
    return (
      <button
        className="unfollow-btn"
        onClick={(e) => {
          e.stopPropagation();
          followUser(user._id)
        }}
      >
        フォロー解除
      </button>
    );
  }
  return (
    <button
      className="follow-btn"
      onClick={(e) => {
        e.stopPropagation();
        followUser(user._id)
      }}
    >
      フォロー
    </button>
  );
};

export default FollowButton;
